class CustomCandleStepNavigatorClass {
	el;
	currentStep = 0;
	steps = [
		"custom-candle__step-name",
		"custom-candle__step-fragrance",
		"custom-candle__step-candle-description",
		"custom-candle__step-color",
		"custom-candle__step-submit",
	];

	constructor(el) {
		console.log("CustomCandleStepNavigatorClass");
		this.el = el;
		this.stepList = this.el.querySelectorAll(".custom-candle__step");

		this.initialize();
		this.gotoCurrentStep();
	}

	initialize() {
		this.el
			.querySelector(".CustomCandleStepNavigator__next")
			?.addEventListener("click", (event) => {
				this.next();
			});
		this.el
			.querySelector(".CustomCandleStepNavigator__prev")
			?.addEventListener("click", (event) => {
				this.prev();
			});
	}

	gotoCurrentStep() {
		for (let i = 0; i < this.stepList.length; i++) {
			this.stepList[i].classList.remove("d-block");
		}

		this.el
			.querySelector("." + this.steps[this.currentStep])
			.classList.add("d-block");
		this.el.setAttribute("data-step", this.currentStep);

		// Update step number in navigator for mobile
		const stepNumberEl = this.el.querySelector(
			".CustomCandleStepNavigator__step-number"
		);
		if (stepNumberEl) {
			const stepNumber = this.currentStep + 1;
			const totalSteps = this.steps.length;
			stepNumberEl.textContent = `${stepNumber}/${totalSteps}`;
		}
	}

	prev() {
		if (this.currentStep == 0) {
			this.currentStep = 0;
		} else {
			this.currentStep--;
		}
		this.gotoCurrentStep();
	}

	next() {
		console.log("next: " + this.currentPos);
		if (this.currentStep == this.steps.length - 1) {
			this.currentStep = this.steps.length - 1;
		} else {
			this.currentStep++;
		}
		this.gotoCurrentStep();
	}
}

class VisualPreviewGenerator {
	constructor(containerElement) {
		console.log("Hello VisualPreviewGenerator");
		this.el = containerElement; // The container element with #card-preview
	}

	renderVisualPreviewWithCanvas(properties) {
		// temp logs to debug
		console.log("Hola renderer!!!");
		console.log("Found card-preview:", this.el.querySelector("#card-preview"));
		console.log(
			"Found front-image:",
			this.el.querySelector("#card-preview .card-preview__front-image")
		);

		let lastX = 0;
		let lastY = 0;

		// Get metafield defaults if available
		const customCandleInterface = document.querySelector(
			"#custom-candle-interface"
		);
		const metafieldCandleName = customCandleInterface
			? customCandleInterface.getAttribute("data-default-candle-name")
			: null;
		const metafieldAnecdote = customCandleInterface
			? customCandleInterface.getAttribute("data-default-anecdote")
			: null;

		let defaults = {
			anecdote: metafieldAnecdote || "your anecdote text",
			candleName: metafieldCandleName || "Candle name",
			candleDescription:
				"Warm and complex, this fragrance's rich woody base is topped with lively floral and citrus notes. Hints of lavender, jasmine, and orange add contour to this candle's inherent simplicity.",
			infoLine1: "Net Wt. 7.8 oz / 221 g          Est. burn time: 40-50 hours",
			infoLine2: "Coconut-Soy Wax Candle      Hand-poured in the USA",
			aboutInfo:
				"All candles are made using natural ingredients with no additives, dyes, or preservatives. Our custom coconut-soy wax blend, cotton core wicks, and premium phthalate-free fragrance oils create a clean burn and powerful scent throw.",
			about: "ABOUT",
			url: "anecdotecandles.com",
			location: "Brooklyn, NY 11232",
		};

		if ("" == properties.candleName) {
			properties.candleName = defaults.candleName;
		}
		if ("" == properties.candleAnecdote) {
			properties.candleAnecdote = defaults.anecdote;
		}
		if ("" == properties.candleDescription) {
			properties.candleDescription = defaults.candleDescription;
		}

		let pattern = /Smells like/gi;
		properties.candleAnecdote = properties.candleAnecdote.replaceAll(
			pattern,
			""
		);

		let canvasWidth = 325 * 2;
		let canvasHeight = 300 * 2;

		function wrapText(context, text, x, y, maxWidth, lineHeight) {
			var lines = text.split("\n");
			var localLastY = 0;
			for (var n = 0; n < lines.length; n++) {
				doWrapText(context, lines[n], x, localLastY + y, maxWidth, lineHeight);
			}

			function doWrapText(context, text, x, y, maxWidth, lineHeight) {
				var words = text.split(" ");
				var line = "";

				for (var n = 0; n < words.length; n++) {
					var testLine = line + words[n] + " ";
					var metrics = context.measureText(testLine);
					var testWidth = metrics.width;
					if (testWidth > maxWidth && n > 0) {
						context.fillText(line, x, y);
						line = words[n] + " ";
						y += lineHeight;
					} else {
						line = testLine;
					}
				}
				context.fillText(line, x, y);
				lastX = x;
				lastY = y;
				if (34 == lineHeight) {
					localLastY = y - 50;
				} else if (50 == lineHeight) {
					localLastY = y - 140;
				}
			}
		}

		if (
			!this.el.querySelector("#card-preview .card-preview__front-image canvas")
		) {
			let logoImage = document.querySelector("#anecdote-and-svg");
			this.el.querySelector(
				"#card-preview .card-preview__front-image"
			).innerHTML =
				'<canvas id="canvas-front"></canvas><div id="custom-candle__preview-logo"  >' +
				logoImage.innerHTML +
				"</div>";
			this.el.querySelector(
				"#card-preview .card-preview__back-image"
			).innerHTML = '<canvas id="canvas-back"></canvas>';
		}
		console.log("Canvas created!");
		let canvasFront = document.getElementById("canvas-front");
		let canvasBack = document.getElementById("canvas-back");
		canvasFront.width = canvasWidth;
		canvasFront.height = canvasHeight;
		canvasBack.width = canvasWidth;
		canvasBack.height = canvasHeight;
		let ctxFront;

		function drawDynamicPart(heightAddition) {
			ctxFront = canvasFront.getContext("2d");
			// Background color removed - canvas is transparent
			// ctxFront.fillStyle = properties.labelColor;
			// ctxFront.fillRect(0, 0, canvasWidth, canvasHeight + heightAddition + 10);
			ctxFront.font = 'normal 50px "DaubentonWeb" ';

			ctxFront.fillStyle = properties.typeColor;
			wrapText(
				ctxFront,
				properties.candleName.trim() + "\u00A0/",
				20,
				105,
				canvasWidth,
				50
			);
			let lastChar = properties.candleAnecdote.trim().slice(-1);
			console.log("lastChar " + lastChar);
			let addOnChar = "";
			if ("." != lastChar) {
				addOnChar = ".";
			}
			if ("?" == lastChar || "!" == lastChar) {
				addOnChar = "";
			}
			wrapText(
				ctxFront,
				"Smells like " +
					properties.candleAnecdote.trim() +
					addOnChar +
					"\u00A0/ " +
					properties.fragranceNote,
				20,
				lastY + 60 + 25,
				canvasWidth,
				50
			);
			//wrapText(ctxFront,properties.fragranceNote, 20, lastY+60, canvasWidth, 60)
		}
		drawDynamicPart(0);
		if (lastY > 480) {
			canvasFront.height = lastY + 170;
			canvasBack.height = lastY + 170;
			drawDynamicPart(170);
		}
		canvasFront.setAttribute("last-y", lastY);

		let ctxBack = canvasBack.getContext("2d");
		// Background color removed - canvas is transparent
		// ctxBack.fillStyle = properties.labelColor;
		// ctxBack.fillRect(0, 0, canvasWidth, canvasHeight);
		ctxBack.fillStyle = properties.typeColor;
		ctxBack.font = ' 27px "PortraitItalic" ';
		ctxBack.letterSpacing = "1px";
		wrapText(
			ctxBack,
			properties.candleDescription,
			20,
			83,
			canvasWidth - 40,
			34
		);

		ctxBack.font = 'normal 23px "PortraitHeavy" ';
		ctxBack.letterSpacing = "3px";
		wrapText(ctxBack, defaults.about, 20, 307, canvasWidth, 31);

		ctxBack.letterSpacing = "0px";
		ctxBack.font = 'normal 24px "PortraitRegular" ';
		wrapText(ctxBack, defaults.aboutInfo, 20, 352, canvasWidth - 30, 34);

		ctxBack.letterSpacing = "0px";
		ctxBack.font = 'normal 24px "PortraitRegular" ';
		wrapText(ctxBack, defaults.url, 20, 550, canvasWidth - 35, 34);

		ctxBack.letterSpacing = "0px";
		ctxBack.font = 'normal 24px "PortraitRegular" ';
		wrapText(ctxBack, defaults.location, 456, 550, canvasWidth - 35, 34);

		ctxBack.beginPath();
		ctxBack.moveTo(20, 505);
		ctxBack.lineTo(628, 505);
		ctxBack.strokeStyle = properties.typeColor;
		ctxBack.stroke();

		let nodelist = this.el.querySelectorAll(
			"#custom-candle__preview-logo path"
		);
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].setAttribute("fill", properties.typeColor);
		}

		//this.drawEvent()
	}
}

class CustomCandleClass {
	el;
	variantSelector;
	keyUpTimeout;
	candleGpt;

	constructor(el) {
		console.log("CustomCandleClass");
		this.el = el;
		this.variantSelector = this.el.querySelector(".variantId-select");

		if (this.variantSelector) {
			// Use the selected variant from the selector (set by Liquid template)
			// This works for any product using the template
			let defaultVariantId = this.variantSelector.value;
			if (defaultVariantId) {
				this.selectVariant(defaultVariantId);
			} else {
				// Fallback: use first available variant if none selected
				if (this.variantSelector.options.length > 0) {
					this.selectVariant(this.variantSelector.options[0].value);
				}
			}
			this.initializeCandleGpt();
			this.initialize();
			let stepNavigator = new CustomCandleStepNavigatorClass(el);
			this.checkEmoji();
		}
	}

	selectVariant(variantId) {
		// force standard jar
		// Check if variant exists in options
		let variantExists = false;
		for (let i = 0; i < this.variantSelector.options.length; i++) {
			if (variantId == this.variantSelector.options[i].value) {
				variantExists = true;
				break;
			}
		}

		// If variant doesn't exist, use first available option
		if (!variantExists && this.variantSelector.options.length > 0) {
			variantId = this.variantSelector.options[0].value;
		}

		this.variantSelector.value = variantId;
		for (let i = 0; i < this.variantSelector.options.length; i++) {
			if (variantId == this.variantSelector.options[i].value) {
				this.variantSelector.options.selected = true;
			} else {
				this.variantSelector.options.selected = false;
			}
		}

		// Safety check before accessing selected option
		if (
			this.variantSelector.selectedIndex >= 0 &&
			this.variantSelector.options[this.variantSelector.selectedIndex]
		) {
			let selectedOption =
				this.variantSelector.options[this.variantSelector.selectedIndex];
			let price = selectedOption.getAttribute("data-variant-price");

			let nodelist = this.el.querySelectorAll(".price-item--regular");
			for (let i = 0; i < nodelist.length; i++) {
				if (price) {
					nodelist[i].innerHTML = price;
				}
			}
		}
	}

	initialize(el) {
		// Safety check before accessing selected option
		if (
			this.variantSelector.selectedIndex >= 0 &&
			this.variantSelector.options[this.variantSelector.selectedIndex]
		) {
			let selectedOptionElement =
				this.variantSelector.options[this.variantSelector.selectedIndex];
			let selectedOption = selectedOptionElement.getAttribute("data-options");
			let currentOptions = this.treatOptions(selectedOption);
			console.log(currentOptions);
			this.buildFragrances();
			this.setFragrance(currentOptions[1]);
			this.setVessel(currentOptions[0]);
			this.buildLabelColors();
			this.getUrlInputs();
		}

		// Ensure first fragrance is selected by default if user hasn't interacted
		const noUserInteraction = this.el.querySelector(
			".customizer-fragrance-selector__no-user-interaction"
		);
		if (noUserInteraction) {
			const fragranceOptions = this.el.querySelectorAll(
				".customizer-fragrance-option"
			);
			const hasSelected = Array.from(fragranceOptions).some((option) =>
				option.classList.contains("customizer-fragrance-option-selected")
			);
			if (!hasSelected && fragranceOptions.length > 0) {
				fragranceOptions[0].classList.add(
					"customizer-fragrance-option-selected"
				);
				this.updateSelector();
			}
		}

		this.buildPreviewButton();
		this.buildSubmitButton();
		this.buildCandleDescriptionResetButton();
		this.setInputListener();
		this.buildQuantitySelector();
		this.candlePreviewEvent();
		this.bindCtaClicks();
	}

	initializeCandleGpt() {
		const toggle = this.el.querySelector(".candle-gpt-mode-toggle");
		if (!toggle) {
			this.candleGpt = null;
			return;
		}

		const generatePanel = this.el.querySelector('[data-mode-panel="generate"]');
		const promptInput = this.el.querySelector("#CandleGptPrompt");
		const promptInputWrapper = generatePanel?.querySelector(
			".candle-gpt-prompt__input-wrapper"
		);
		const promptErrorMessage = promptInputWrapper?.querySelector(
			".custom-candle__error-message"
		);
		const submitButton = this.el.querySelector(".candle-gpt-submit");
		const submitButtonIcon = submitButton?.querySelector("svg");
		const feedbackMessage = this.el.querySelector(
			".candle-gpt-feedback__message"
		);
		const loader = this.el.querySelector(".candle-gpt-feedback__loader");
		const resultsWrapper = this.el.querySelector("#candle-gpt-results");
		const carousel = resultsWrapper?.querySelector(
			".candle-gpt-results__carousel"
		);
		const viewport = carousel?.querySelector(".candle-gpt-results__viewport");
		const container = carousel?.querySelector(".candle-gpt-results__container");
		const prevButton = resultsWrapper?.querySelector(
			".candle-gpt-results__prev"
		);
		const nextButton = resultsWrapper?.querySelector(
			".candle-gpt-results__next"
		);
		const step = this.el.querySelector(".custom-candle__step-name");

		const indicatorCurrent = resultsWrapper?.querySelector(
			".candle-gpt-results__indicator-current"
		);
		const indicatorTotal = resultsWrapper?.querySelector(
			".candle-gpt-results__indicator-total"
		);
		const hideFragranceOnCards =
			this.el
				.querySelector("#custom-candle-interface")
				?.getAttribute("data-hide-ai-fragrance") === "true";

		this.candleGpt = {
			toggle,
			buttons: Array.from(toggle.querySelectorAll("[data-mode]")),
			generatePanel,
			promptInput,
			promptInputWrapper,
			promptErrorMessage,
			submitButton,
			submitButtonIcon,
			originalButtonIcon: submitButtonIcon?.outerHTML || null,
			feedbackMessage,
			loader,
			resultsWrapper,
			carousel,
			viewport,
			container,
			prevButton,
			nextButton,
			step,
			indicatorCurrent,
			indicatorTotal,
			hideFragranceOnCards,
			mode: "generate",
			isLoading: false,
			results: [],
			selectedIndex: null,
			embla: null,
			fieldsManuallyEdited: false,
		};

		this.candleGpt.buttons.forEach((button) => {
			button.addEventListener("click", (event) => {
				event.preventDefault();
				const mode =
					event.currentTarget.getAttribute("data-mode") || "generate";
				this.setCandleGptMode(mode);
			});
		});

		const promptForm = generatePanel?.querySelector(".candle-gpt-prompt-form");

		if (promptForm) {
			promptForm.addEventListener("submit", (event) => {
				event.preventDefault();
				this.submitCandleGptPrompt();
			});
		}

		if (submitButton) {
			submitButton.addEventListener("click", (event) => {
				event.preventDefault();
				this.submitCandleGptPrompt();
			});
		}

		// Clear error when user types in prompt input
		if (promptInput) {
			const clearError = () => {
				this.clearPromptError();
			};
			promptInput.addEventListener("input", clearError);
			promptInput.addEventListener("keydown", clearError);
			// Rotate to front when focusing on prompt input (for generating/regenerating AI responses)
			promptInput.addEventListener("focus", () => {
				this.rotateLabelToView("front");
			});
		}

		this.setCandleGptMode("generate");
	}

	setCandleGptMode(mode = "generate") {
		if (!this.candleGpt) {
			return;
		}
		const normalizedMode = "write" === mode ? "write" : "generate";
		this.candleGpt.mode = normalizedMode;
		this.candleGpt.toggle.setAttribute("data-active-mode", normalizedMode);

		this.candleGpt.buttons.forEach((button) => {
			if (button.getAttribute("data-mode") === normalizedMode) {
				button.classList.add("is-active");
			} else {
				button.classList.remove("is-active");
			}
		});

		if (this.candleGpt.step) {
			this.candleGpt.step.setAttribute("data-candle-gpt-mode", normalizedMode);
		}

		if (this.candleGpt.generatePanel) {
			if ("generate" === normalizedMode) {
				this.candleGpt.generatePanel.classList.remove("d-none");
			} else {
				this.candleGpt.generatePanel.classList.add("d-none");
			}
		}

		// Show input fields when "Write it" mode is selected
		const fieldsContainer = this.el.querySelector(".candle-gpt-fields");
		if (fieldsContainer) {
			if ("write" === normalizedMode) {
				fieldsContainer.classList.add("is-visible");
			} else {
				// Only hide if no result has been selected
				if (this.candleGpt.selectedIndex === null) {
					fieldsContainer.classList.remove("is-visible");
				}
			}
		}

		if ("generate" === normalizedMode) {
			this.candleGpt.promptInput?.focus({ preventScroll: true });
		} else {
			this.showCandleGptFeedback("", "info");
			// Clear any error state when switching to write mode
			this.clearPromptError();
		}
	}

	ensureCandleGptLoader() {
		if (!this.candleGpt?.loader) {
			return;
		}
		if (this.candleGpt.loader.childElementCount > 0) {
			return;
		}
		const template = document.getElementById("spinning-loader");
		if (template) {
			this.candleGpt.loader.innerHTML = template.innerHTML;
		}
	}

	setCandleGptLoading(isLoading) {
		if (!this.candleGpt) {
			return;
		}
		this.candleGpt.isLoading = isLoading;
		if (this.candleGpt.submitButton) {
			if (isLoading) {
				this.candleGpt.submitButton.setAttribute("disabled", "disabled");
				// Replace button icon with spinner
				if (
					this.candleGpt.submitButtonIcon &&
					this.candleGpt.originalButtonIcon
				) {
					const template = document.getElementById("spinning-loader");
					if (template) {
						const spinnerHtml = template.innerHTML;
						const tempDiv = document.createElement("div");
						tempDiv.innerHTML = spinnerHtml;
						const spinnerSvg = tempDiv.querySelector("svg");
						if (spinnerSvg) {
							spinnerSvg.setAttribute("width", "21");
							spinnerSvg.setAttribute("height", "21");
							spinnerSvg.setAttribute("viewBox", "0 0 40 40");
							spinnerSvg.style.width = "21px";
							spinnerSvg.style.height = "21px";
							this.candleGpt.submitButtonIcon.outerHTML = spinnerSvg.outerHTML;
							// Update reference to the new SVG
							this.candleGpt.submitButtonIcon =
								this.candleGpt.submitButton.querySelector("svg");
						}
					}
				}
			} else {
				this.candleGpt.submitButton.removeAttribute("disabled");
				// Restore original button icon
				if (
					this.candleGpt.submitButtonIcon &&
					this.candleGpt.originalButtonIcon
				) {
					this.candleGpt.submitButtonIcon.outerHTML =
						this.candleGpt.originalButtonIcon;
					// Re-select the icon after restoring
					this.candleGpt.submitButtonIcon =
						this.candleGpt.submitButton.querySelector("svg");
				}
			}
		}
		if (this.candleGpt.loader) {
			// Keep loader hidden since we're using button icon instead
			this.candleGpt.loader.classList.add("d-none");
		}
	}

	showCandleGptFeedback(message = "", tone = "info") {
		if (!this.candleGpt?.feedbackMessage) {
			return;
		}
		const feedbackEl = this.candleGpt.feedbackMessage;
		feedbackEl.textContent = message;
		feedbackEl.classList.remove("is-error", "is-success", "is-info");
		if (message) {
			feedbackEl.classList.add(`is-${tone}`);
		}
	}

	showPromptError(message) {
		if (
			!this.candleGpt?.promptInputWrapper ||
			!this.candleGpt?.promptErrorMessage
		) {
			return;
		}
		// Update error message text
		this.candleGpt.promptErrorMessage.textContent = message;
		// Show error message
		this.candleGpt.promptInputWrapper.classList.add("custom-candle__has-error");
		// Clear feedback message to avoid duplication
		this.showCandleGptFeedback("", "info");
		// Focus the input
		this.candleGpt.promptInput?.focus({ preventScroll: true });
	}

	clearPromptError() {
		if (this.candleGpt?.promptInputWrapper) {
			this.candleGpt.promptInputWrapper.classList.remove(
				"custom-candle__has-error"
			);
		}
	}

	submitCandleGptPrompt() {
		if (!this.candleGpt || "generate" !== this.candleGpt.mode) {
			return;
		}
		if (this.candleGpt.isLoading) {
			return;
		}
		const prompt = this.candleGpt.promptInput?.value.trim() || "";
		if ("" === prompt) {
			this.showPromptError("Please share the vibe first so our AI can help.");
			return;
		}
		document.body.setAttribute('data-last-prompt',prompt)

		// Rotate to front when generating AI responses
		this.rotateLabelToView("front");

		// Clear error if prompt is valid
		this.clearPromptError();

		// this.showCandleGptFeedback("Mixing up some ideas…", "info");
		this.setCandleGptLoading(true);

		// Show loading placeholder slides immediately
		const existingResults = this.candleGpt.results || [];
		const placeholderStartIndex = existingResults.length;
		this.createLoadingPlaceholders(placeholderStartIndex);

		const xhr = new XMLHttpRequest();
		xhr.open("POST", "https://candlegpt-prod.uc.r.appspot.com", true);
		xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				this.setCandleGptLoading(false);
				if (xhr.status === 200) {
					this.handleCandleGptSuccess(xhr.responseText, placeholderStartIndex);
				} else if (xhr.status === 400) {
					// Remove loading placeholders on error
					if (
						placeholderStartIndex !== null &&
						placeholderStartIndex !== undefined
					) {
						this.removeLoadingPlaceholders();
					}
					this.handleCandleGptError(xhr.responseText);
				} else {
					console.error("CandleGPT error", xhr.status, xhr.responseText);
					// Remove loading placeholders on error
					if (
						placeholderStartIndex !== null &&
						placeholderStartIndex !== undefined
					) {
						this.removeLoadingPlaceholders();
					}
					this.showPromptError(
						"Something went wrong on our side — please try again."
					);
				}
			}
		};
		xhr.onerror = () => {
			this.setCandleGptLoading(false);
			// Remove loading placeholders on error
			if (
				placeholderStartIndex !== null &&
				placeholderStartIndex !== undefined
			) {
				this.removeLoadingPlaceholders();
			}
			this.showPromptError(
				"We couldn't reach CandleGPT. Check your connection and try again."
			);
		};
		xhr.send(JSON.stringify({ user_input: prompt }));
	}

	createLoadingPlaceholders(startIndex) {
		if (!this.candleGpt?.container) {
			return;
		}

		// Create 3 placeholder slides with loading spinners
		for (let i = 0; i < 3; i++) {
			const slide = document.createElement("div");
			slide.className = "candle-gpt-result-card__slide";
			slide.setAttribute("data-placeholder-index", (startIndex + i).toString());
			slide.setAttribute("data-is-placeholder", "true");

			const card = document.createElement("div");
			card.className = "candle-gpt-result-card candle-gpt-result-card--loading";

			const spinner = document.createElement("div");
			spinner.className = "candle-gpt-result-card__spinner";

			card.appendChild(spinner);
			slide.appendChild(card);
			this.candleGpt.container.appendChild(slide);
		}

		// Reinit Embla to recognize new slides and animate to them
		if (this.candleGpt.embla) {
			setTimeout(() => {
				if (this.candleGpt.embla) {
					// Reinit to recognize new slides
					this.candleGpt.embla.reInit();

					// Wait for reInit to complete and layout to settle, then animate to first placeholder
					// Use multiple requestAnimationFrame calls to ensure layout is complete
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							setTimeout(() => {
								if (this.candleGpt.embla) {
									// Scroll to first placeholder slide with smooth animation
									// The second parameter (false) enables smooth scrolling, (true) would jump
									this.candleGpt.embla.scrollTo(startIndex, false);

									// Update indicator after scroll animation
									setTimeout(() => {
										if (
											this.candleGpt.indicatorCurrent &&
											this.candleGpt.indicatorTotal
										) {
											const selectedIndex =
												this.candleGpt.embla.selectedScrollSnap();
											const totalSlides =
												this.candleGpt.embla.slideNodes().length;
											this.candleGpt.indicatorCurrent.textContent = (
												selectedIndex + 1
											).toString();
											this.candleGpt.indicatorTotal.textContent =
												totalSlides.toString();
										}
									}, 100);
								}
							}, 200);
						});
					});
				}
			}, 50);
		} else {
			// If Embla isn't initialized yet, wait for it and then scroll
			const checkEmbla = setInterval(() => {
				if (this.candleGpt.embla) {
					clearInterval(checkEmbla);
					requestAnimationFrame(() => {
						setTimeout(() => {
							if (this.candleGpt.embla) {
								// Scroll to first placeholder slide with smooth animation
								// The second parameter (false) enables smooth scrolling
								this.candleGpt.embla.scrollTo(startIndex, false);
								setTimeout(() => {
									if (
										this.candleGpt.indicatorCurrent &&
										this.candleGpt.indicatorTotal
									) {
										const selectedIndex =
											this.candleGpt.embla.selectedScrollSnap();
										const totalSlides =
											this.candleGpt.embla.slideNodes().length;
										this.candleGpt.indicatorCurrent.textContent = (
											selectedIndex + 1
										).toString();
										this.candleGpt.indicatorTotal.textContent =
											totalSlides.toString();
									}
								}, 100);
							}
						}, 150);
					});
				}
			}, 50);

			// Stop checking after 2 seconds
			setTimeout(() => {
				clearInterval(checkEmbla);
			}, 2000);
		}
	}

	removeLoadingPlaceholders() {
		if (!this.candleGpt?.container) {
			return;
		}
		const placeholders = this.candleGpt.container.querySelectorAll(
			'[data-is-placeholder="true"]'
		);
		placeholders.forEach((placeholder) => {
			placeholder.remove();
		});
	}

	handleCandleGptError(rawResponse) {
		let errorMessage =
			"We ran into an issue with that prompt. Try tweaking it and resubmitting.";
		try {
			const payload = JSON.parse(rawResponse);
			if (payload?.error) {
				errorMessage = payload.error;
			}
		} catch (error) {
			console.error("CandleGPT error payload parse", error);
		}
		// Show error in the styled error message div
		this.showPromptError(errorMessage);
	}

	handleCandleGptSuccess(rawResponse, placeholderStartIndex = null) {
		let payload;
		try {
			payload = JSON.parse(rawResponse);
		} catch (error) {
			console.error("CandleGPT success payload parse", error);
			this.showPromptError(
				"We had trouble understanding the response. Please try again."
			);
			// Remove loading placeholders on error
			if (placeholderStartIndex !== null) {
				this.removeLoadingPlaceholders();
			}
			return;
		}

		const formatted = Array.isArray(payload?.formatted_responses)
			? payload.formatted_responses
			: [];
		const results = [];

		formatted.forEach((item) => {
			if ("string" !== typeof item) {
				return;
			}
			const parts = item.split("/");
			results.push({
				title: parts[0]?.trim() || "",
				text: parts[1]?.trim() || "",
				fragranceFamily: parts[2]?.trim() || "",
				fragranceNote: parts[3]?.trim() || "",
			});
		});

		if (!results.length) {
			// Remove loading placeholders if no results
			if (placeholderStartIndex !== null) {
				this.removeLoadingPlaceholders();
			}
			// Only clear results if this is the first request (no existing results)
			if (!this.candleGpt.results || this.candleGpt.results.length === 0) {
				this.candleGpt.results = [];
				this.renderCandleGptResults([], 0);
			}
			this.showCandleGptFeedback(
				"No ideas yet. Try giving CandleGPT a little more detail.",
				"error"
			);
			return;
		}

		// Remove loading placeholders before adding real results
		if (placeholderStartIndex !== null) {
			this.removeLoadingPlaceholders();
		}

		// Append new results to existing ones instead of replacing
		const existingResults = this.candleGpt.results || [];
		const allResults = [...existingResults, ...results];
		this.candleGpt.results = allResults;

		// Track where new results start
		const newResultsStartIndex =
			placeholderStartIndex !== null
				? placeholderStartIndex
				: existingResults.length;

		this.renderCandleGptResults(results, newResultsStartIndex);
		// this.showCandleGptFeedback(
		// 	"Tap a result to fill in your candle. Want a remix? Try another prompt.",
		// 	"success"
		// );
	}

	renderCandleGptResults(newResults, startIndex = 0) {
		if (!this.candleGpt?.resultsWrapper || !this.candleGpt.container) {
			return;
		}

		const isFirstRender = startIndex === 0;

		// Only clean up and reset on first render
		if (isFirstRender) {
			// Clean up existing carousel
			if (this.candleGpt.embla) {
				this.candleGpt.embla.destroy();
				this.candleGpt.embla = null;
			}

			this.candleGpt.container.innerHTML = "";
			this.candleGpt.selectedIndex = null;
		}

		if (!newResults || !newResults.length) {
			if (isFirstRender) {
				this.candleGpt.resultsWrapper.classList.add("d-none");
			}
			return;
		}

		// Create slides for Embla carousel
		newResults.forEach((result, relativeIndex) => {
			const absoluteIndex = startIndex + relativeIndex;

			// Check if there's already a placeholder at this index
			const existingPlaceholder = this.candleGpt.container.querySelector(
				`[data-placeholder-index="${absoluteIndex}"][data-is-placeholder="true"]`
			);

			const slide = existingPlaceholder || document.createElement("div");
			if (!existingPlaceholder) {
				slide.className = "candle-gpt-result-card__slide";
				this.candleGpt.container.appendChild(slide);
			} else {
				// Remove placeholder attributes and clear content
				slide.removeAttribute("data-placeholder-index");
				slide.removeAttribute("data-is-placeholder");
				slide.innerHTML = "";
			}

			const card = document.createElement("div");
			card.className = "candle-gpt-result-card";
			card.setAttribute("data-result-index", absoluteIndex.toString());

			const titleEl = document.createElement("div");
			titleEl.className = "candle-gpt-result-card__title";
			titleEl.textContent = result.title || "Candle Name";

			const anecdoteEl = document.createElement("div");
			anecdoteEl.className = "candle-gpt-result-card__anecdote";
			anecdoteEl.textContent = result.text || "";

			let fragranceEl = null;
			if (!this.candleGpt?.hideFragranceOnCards) {
				fragranceEl = document.createElement("div");
				fragranceEl.className = "candle-gpt-result-card__fragrance";
				if (result.fragranceNote) {
					fragranceEl.textContent = `${result.fragranceNote}`;
				} else if (result.fragranceFamily) {
					fragranceEl.textContent = `Fragrance family: ${result.fragranceFamily}`;
				} else {
					fragranceEl.textContent = "";
				}
			}

			card.addEventListener("click", (event) => {
				this.applyCandleGptResult(absoluteIndex);
			});

			card.appendChild(titleEl);
			card.appendChild(anecdoteEl);
			if (fragranceEl && fragranceEl.textContent) {
				card.appendChild(fragranceEl);
			}

			slide.appendChild(card);
		});

		// Initialize or reinitialize Embla carousel
		const initEmbla = () => {
			if (typeof EmblaCarousel === "undefined") {
				// Retry if Embla not loaded yet (max 10 attempts = 1 second)
				if (initEmbla.retryCount === undefined) {
					initEmbla.retryCount = 0;
				}
				if (initEmbla.retryCount < 10) {
					initEmbla.retryCount++;
					setTimeout(initEmbla, 100);
				} else {
					console.warn("EmblaCarousel library failed to load");
				}
				return;
			}

			if (!this.candleGpt.viewport) {
				console.warn("Embla viewport element not found");
				return;
			}

			// Initialize carousel if it doesn't exist, otherwise reinit
			if (!this.candleGpt.embla) {
				console.log("Initializing Embla carousel", this.candleGpt.viewport);

				this.candleGpt.embla = EmblaCarousel(this.candleGpt.viewport, {
					align: "start",
					dragFree: false,
					containScroll: "trimSnaps",
				});

				// Setup prev/next buttons and indicator (only once)
				if (this.candleGpt.prevButton && this.candleGpt.nextButton) {
					const setupPrevNextBtns = () => {
						const prevBtnEnabled = this.candleGpt.embla.canScrollPrev();
						const nextBtnEnabled = this.candleGpt.embla.canScrollNext();

						this.candleGpt.prevButton.disabled = !prevBtnEnabled;
						this.candleGpt.nextButton.disabled = !nextBtnEnabled;
					};

					const updateIndicator = () => {
						if (
							this.candleGpt.indicatorCurrent &&
							this.candleGpt.indicatorTotal
						) {
							const selectedIndex = this.candleGpt.embla.selectedScrollSnap();
							const totalSlides = this.candleGpt.embla.slideNodes().length;
							this.candleGpt.indicatorCurrent.textContent = (
								selectedIndex + 1
							).toString();
							this.candleGpt.indicatorTotal.textContent =
								totalSlides.toString();
						}
					};

					this.candleGpt.prevButton.addEventListener("click", () => {
						this.candleGpt.embla.scrollPrev();
					});

					this.candleGpt.nextButton.addEventListener("click", () => {
						this.candleGpt.embla.scrollNext();
					});

					this.candleGpt.embla.on("select", () => {
						setupPrevNextBtns();
						updateIndicator();
						// Automatically apply the currently selected slide
						const selectedIndex = this.candleGpt.embla.selectedScrollSnap();
						// Only apply if it's different from the stored selection (user actively selected a different card)
						// If it's the same as stored, just update highlight (might be programmatic scroll to restore position)
						if (
							this.candleGpt.selectedIndex === null ||
							this.candleGpt.selectedIndex !== selectedIndex
						) {
							this.applyCandleGptResult(selectedIndex);
						} else {
							// Same selection - just update highlight, don't re-apply
							this.highlightCandleGptResult(selectedIndex);
						}
					});
					this.candleGpt.embla.on("init", () => {
						setupPrevNextBtns();
						updateIndicator();
					});
					this.candleGpt.embla.on("reInit", () => {
						setupPrevNextBtns();
						updateIndicator();
						// Restore the previously selected slide if we have one stored
						if (
							this.candleGpt.selectedIndex !== null &&
							this.candleGpt.selectedIndex !== undefined
						) {
							const currentIndex = this.candleGpt.embla.selectedScrollSnap();
							// Scroll to the stored selected index
							this.candleGpt.embla.scrollTo(
								this.candleGpt.selectedIndex,
								false
							);
							// If the carousel was at a different position, re-apply the stored result
							// This ensures the preview shows the correct result even if carousel reset to 0
							if (currentIndex !== this.candleGpt.selectedIndex) {
								// Use setTimeout to ensure scroll completes before applying
								setTimeout(() => {
									this.applyCandleGptResult(this.candleGpt.selectedIndex);
								}, 100);
							}
						} else {
							// If no stored selection, apply the currently selected slide
							const selectedIndex = this.candleGpt.embla.selectedScrollSnap();
							if (selectedIndex !== null && selectedIndex !== undefined) {
								this.applyCandleGptResult(selectedIndex);
							}
						}
					});
					setupPrevNextBtns();
					updateIndicator();
				}
			}

			// Reinit to ensure dimensions are calculated correctly
			// Wait for DOM to settle and browser to calculate dimensions before reinit
			// Only reinit if carousel already exists (not on first render where init happens in setTimeout)
			if (this.candleGpt.embla) {
				setTimeout(() => {
					if (this.candleGpt.embla) {
						// Reinit after DOM has fully settled and dimensions are calculated
						this.candleGpt.embla.reInit();

						// Scroll to first new result if this is an append operation
						if (!isFirstRender && startIndex !== undefined) {
							this.candleGpt.embla.scrollTo(startIndex, false);
						}

						// Update indicator after reinit
						if (
							this.candleGpt.indicatorCurrent &&
							this.candleGpt.indicatorTotal
						) {
							const selectedIndex = this.candleGpt.embla.selectedScrollSnap();
							const totalSlides = this.candleGpt.embla.slideNodes().length;
							this.candleGpt.indicatorCurrent.textContent = (
								selectedIndex + 1
							).toString();
							this.candleGpt.indicatorTotal.textContent =
								totalSlides.toString();
						}
					}
				}, 150); // Increased delay to ensure DOM has settled
			}
		};

		// Wait a bit for DOM to settle, then initialize
		setTimeout(() => {
			initEmbla();
		}, 50);

		this.candleGpt.resultsWrapper.classList.remove("d-none");

		// Automatically apply and highlight the first result (first render) or first new result (append)
		if (newResults.length > 0) {
			setTimeout(() => {
				this.applyCandleGptResult(startIndex);
			}, 150);
		}
	}

	highlightCandleGptResult(index) {
		if (!this.candleGpt?.container) {
			return;
		}
		const cards = this.candleGpt.container.querySelectorAll(
			".candle-gpt-result-card"
		);
		cards.forEach((card) => {
			const cardIndex = card.getAttribute("data-result-index");
			if (null !== index && cardIndex === index.toString()) {
				card.classList.add("is-selected");
				// Scroll to selected card in carousel
				if (this.candleGpt.embla) {
					this.candleGpt.embla.scrollTo(parseInt(cardIndex));
				}
			} else {
				card.classList.remove("is-selected");
			}
		});
	}

	applyCandleGptResult(index) {
		if (!this.candleGpt || !Array.isArray(this.candleGpt.results)) {
			return;
		}
		const result = this.candleGpt.results[index];
		if (!result) {
			return;
		}

		const candleNameEl = this.el.querySelector("#CandleName");
		const anecdoteEl = this.el.querySelector("#CandleAnecdote");

		// Check if fields have been manually edited - if so, don't overwrite them
		// unless the user is explicitly selecting a different AI result
		if (
			this.candleGpt.fieldsManuallyEdited &&
			this.candleGpt.selectedIndex === index
		) {
			// User has edited fields and we're re-applying the same result (likely from carousel event)
			// Don't overwrite their edits - just update the preview with current values
			this.candlePreviewEvent();
			return;
		}

		if (candleNameEl) {
			candleNameEl.value = result.title || "";
		}

		if (anecdoteEl) {
			anecdoteEl.value = result.text || "";
			anecdoteEl.classList.remove("no-rounded-bottom");
		}

		if (result.fragranceNote) {
			this.setFragranceFromCandleGpt(result.fragranceNote);
		}

		this.candleGpt.selectedIndex = index;
		// Reset the manual edit flag when applying a new result
		this.candleGpt.fieldsManuallyEdited = false;
		this.highlightCandleGptResult(index);

		// Show input fields when a generated option is selected
		const fieldsContainer = this.el.querySelector(".candle-gpt-fields");
		if (fieldsContainer) {
			fieldsContainer.classList.add("is-visible");
		}

		this.candlePreviewEvent();
		// this.showCandleGptFeedback(
		// 	"All set! Tweak anything you like or try a new prompt.",
		// 	"success"
		// );
	}

	setFragranceFromCandleGpt(fragranceNote) {
		if (!fragranceNote) {
			return;
		}
		const trimmedNote = fragranceNote.trim();
		if ("" === trimmedNote) {
			return;
		}

		let option = this.el.querySelector(
			`.customizer-fragrance-option[data-id="${trimmedNote}"]`
		);
		if (!option) {
			const lower = trimmedNote.toLowerCase();
			option = Array.from(
				this.el.querySelectorAll(".customizer-fragrance-option")
			).find((candidate) => {
				const candidateValue = candidate.getAttribute("data-id") || "";
				return candidateValue.toLowerCase() === lower;
			});
		}

		if (option) {
			option.dispatchEvent(new Event("click", { bubbles: true }));
		}
	}

	setInputListener() {
		let nodelist = this.el.querySelectorAll(
			".custom-candle-configurator input, .custom-candle-configurator textarea"
		);
		for (let i = 0; i < nodelist.length; i++) {
			console.log("setInputListener");
			nodelist[i].addEventListener("focusout", (event) => {
				this.candlePreviewEvent(event);
			});
			nodelist[i].addEventListener("keyup", (event) => {
				this.keyUpHandler();
			});
			// Track manual edits to prevent AI results from overwriting user changes
			nodelist[i].addEventListener("input", (event) => {
				// Only mark as manually edited if an AI result was previously selected
				if (this.candleGpt && this.candleGpt.selectedIndex !== null) {
					// Check if the current value differs from the stored result
					const candleNameEl = this.el.querySelector("#CandleName");
					const anecdoteEl = this.el.querySelector("#CandleAnecdote");
					const currentResult =
						this.candleGpt.results[this.candleGpt.selectedIndex];

					if (currentResult) {
						const nameChanged =
							candleNameEl &&
							candleNameEl.value !== (currentResult.title || "");
						const anecdoteChanged =
							anecdoteEl && anecdoteEl.value !== (currentResult.text || "");

						if (nameChanged || anecdoteChanged) {
							this.candleGpt.fieldsManuallyEdited = true;
							// Update the stored result to reflect user's edits
							if (candleNameEl && nameChanged) {
								currentResult.title = candleNameEl.value;
							}
							if (anecdoteEl && anecdoteChanged) {
								currentResult.text = anecdoteEl.value;
							}
						}
					}
				}
			});
		}

		// Limit the total number of line breaks in the Anecdote field to 2
		const anecdoteEl = this.el.querySelector("#CandleAnecdote");
		if (anecdoteEl) {
			anecdoteEl.addEventListener("input", (event) => {
				const value = event.target.value;
				const cursorPosition = event.target.selectionStart;

				// Count how many line breaks exist
				const lineBreakMatches = value.match(/\n/g);
				const lineBreakCount = lineBreakMatches ? lineBreakMatches.length : 0;

				// If there's more than 2 line breaks, keep only the first 2
				let limitedValue = value;
				if (lineBreakCount > 2) {
					// Find all line break positions
					const lineBreakPositions = [];
					let searchIndex = 0;
					while (searchIndex < value.length) {
						const index = value.indexOf("\n", searchIndex);
						if (index === -1) break;
						lineBreakPositions.push(index);
						searchIndex = index + 1;
					}

					// Keep everything up to and including the second line break,
					// then remove all subsequent line breaks
					if (lineBreakPositions.length >= 2) {
						const secondLineBreakIndex = lineBreakPositions[1];
						const beforeSecond = value.substring(0, secondLineBreakIndex + 1);
						const afterSecond = value.substring(secondLineBreakIndex + 1);
						const afterSecondLimited = afterSecond.replace(/\n/g, "");
						limitedValue = beforeSecond + afterSecondLimited;
					}
				}

				if (value !== limitedValue) {
					// Calculate how many characters were removed before the cursor
					const textBeforeCursor = value.substring(0, cursorPosition);

					// Find line break positions in the full value
					const lineBreakPositions = [];
					let searchIndex = 0;
					while (searchIndex < value.length) {
						const index = value.indexOf("\n", searchIndex);
						if (index === -1) break;
						lineBreakPositions.push(index);
						searchIndex = index + 1;
					}

					let textBeforeCursorLimited = textBeforeCursor;
					if (lineBreakPositions.length > 2) {
						const secondLineBreakIndex = lineBreakPositions[1];
						if (cursorPosition <= secondLineBreakIndex) {
							// Cursor is before or at the second line break, no changes before cursor
							textBeforeCursorLimited = textBeforeCursor;
						} else {
							// Cursor is after the second line break
							// Count line breaks before cursor (excluding the first 2)
							const textAfterSecond = textBeforeCursor.substring(
								secondLineBreakIndex + 1
							);
							const lineBreaksAfterSecond = (textAfterSecond.match(/\n/g) || [])
								.length;
							// Remove those line breaks
							textBeforeCursorLimited =
								textBeforeCursor.substring(0, secondLineBreakIndex + 1) +
								textAfterSecond.replace(/\n/g, "");
						}
					}

					const removedBeforeCursor =
						textBeforeCursor.length - textBeforeCursorLimited.length;

					// Update value
					event.target.value = limitedValue;

					// Restore cursor position (adjust for removed characters before cursor)
					const newCursorPosition = Math.max(
						0,
						cursorPosition - removedBeforeCursor
					);
					event.target.setSelectionRange(newCursorPosition, newCursorPosition);
				}
			});
		}

		// Limit consecutive line breaks in the Candle Description field to 2
		// and limit the total number of double line breaks (\n\n) to 1
		const candleDescriptionEl = this.el.querySelector("#CandleDescription");
		if (candleDescriptionEl) {
			candleDescriptionEl.addEventListener("input", (event) => {
				let value = event.target.value;
				const cursorPosition = event.target.selectionStart;

				// First: Replace 3 or more consecutive line breaks with 2 line breaks
				let limitedValue = value.replace(/\n{3,}/g, "\n\n");

				// Second: Limit the total number of double line breaks (\n\n) to 1
				const doubleLineBreakMatches = limitedValue.match(/\n\n/g);
				const doubleLineBreakCount = doubleLineBreakMatches
					? doubleLineBreakMatches.length
					: 0;

				if (doubleLineBreakCount > 1) {
					// Find the first double line break
					const firstDoubleLineBreakIndex = limitedValue.indexOf("\n\n");
					if (firstDoubleLineBreakIndex !== -1) {
						// Keep everything up to and including the first double line break,
						// then replace all subsequent double line breaks with single line breaks
						const beforeFirst = limitedValue.substring(
							0,
							firstDoubleLineBreakIndex + 2
						);
						const afterFirst = limitedValue.substring(
							firstDoubleLineBreakIndex + 2
						);
						const afterFirstLimited = afterFirst.replace(/\n\n/g, "\n");
						limitedValue = beforeFirst + afterFirstLimited;
					}
				}

				if (value !== limitedValue) {
					// Calculate how many characters were removed before the cursor
					const textBeforeCursor = value.substring(0, cursorPosition);
					let textBeforeCursorLimited = textBeforeCursor.replace(
						/\n{3,}/g,
						"\n\n"
					);

					// Apply the same double line break limiting to text before cursor
					const doubleLineBreakMatchesBefore =
						textBeforeCursorLimited.match(/\n\n/g);
					const doubleLineBreakCountBefore = doubleLineBreakMatchesBefore
						? doubleLineBreakMatchesBefore.length
						: 0;

					if (doubleLineBreakCountBefore > 1) {
						const firstDoubleLineBreakIndexBefore =
							textBeforeCursorLimited.indexOf("\n\n");
						if (firstDoubleLineBreakIndexBefore !== -1) {
							const beforeFirstBefore = textBeforeCursorLimited.substring(
								0,
								firstDoubleLineBreakIndexBefore + 2
							);
							const afterFirstBefore = textBeforeCursorLimited.substring(
								firstDoubleLineBreakIndexBefore + 2
							);
							const afterFirstLimitedBefore = afterFirstBefore.replace(
								/\n\n/g,
								"\n"
							);
							textBeforeCursorLimited =
								beforeFirstBefore + afterFirstLimitedBefore;
						}
					}

					const removedBeforeCursor =
						textBeforeCursor.length - textBeforeCursorLimited.length;

					// Update value
					event.target.value = limitedValue;

					// Restore cursor position (adjust for removed characters before cursor)
					const newCursorPosition = Math.max(
						0,
						cursorPosition - removedBeforeCursor
					);
					event.target.setSelectionRange(newCursorPosition, newCursorPosition);
				}
			});

			candleDescriptionEl.addEventListener("input", (event) => {
				const trimmedValue = event.target.value.trim();
				if (trimmedValue === "") {
					event.target.setAttribute("data-user-cleared", "true");
				} else {
					event.target.removeAttribute("data-user-cleared");
				}
			});
		}

		// Set up automatic label rotation based on field focus
		this.setupAutomaticLabelRotation();
	}

	/**
	 * Rotate label to front or back based on active field
	 */
	rotateLabelToView(view) {
		// Get the 3D preview instance
		let visualPreview = null;
		if (this.visualPreview) {
			visualPreview = this.visualPreview;
		} else if (typeof window.getVisualPreviewInstance === "function") {
			visualPreview = window.getVisualPreviewInstance();
		} else if (window.currentVisualPreviewInstance) {
			visualPreview = window.currentVisualPreviewInstance;
		}

		if (visualPreview && visualPreview.threeDPreview) {
			if (view === "front") {
				visualPreview.threeDPreview.rotateToFront(true);
			} else if (view === "back") {
				visualPreview.threeDPreview.rotateToBack(true);
			}
		}
	}

	/**
	 * Set up automatic label rotation based on field focus
	 */
	setupAutomaticLabelRotation() {
		// Rotate to front when focusing on Candle Name
		const candleNameEl = this.el.querySelector("#CandleName");
		if (candleNameEl) {
			candleNameEl.addEventListener("focus", () => {
				this.rotateLabelToView("front");
			});
		}

		// Rotate to front when focusing on Anecdote
		const candleAnecdoteEl = this.el.querySelector("#CandleAnecdote");
		if (candleAnecdoteEl) {
			candleAnecdoteEl.addEventListener("focus", () => {
				this.rotateLabelToView("front");
			});
		}

		// Rotate to back when focusing on Candle Description
		const candleDescriptionEl = this.el.querySelector("#CandleDescription");
		if (candleDescriptionEl) {
			candleDescriptionEl.addEventListener("focus", () => {
				this.rotateLabelToView("back");
			});
		}

		// Note: Fragrance and color option rotation is handled in buildFragrances() and buildLabelColors()
		// since those elements are dynamically created
	}

	keyUpHandler() {
		clearTimeout(this.keyUpTimeout);
		this.keyUpTimeout = setTimeout(() => {
			this.candlePreviewEvent(null);
		}, 500);
	}

	bindCtaClicks() {
		this.el
			.querySelector(".custom-candle__progress-bar__make-new")
			?.addEventListener("click", (event) => {
				window.location = "https://anecdotecandles.com/products/custom-candle";
			});

		this.el
			.querySelector(".custom-candle__print-data-form-close-button")
			?.addEventListener("click", (event) => {
				document.body.classList.remove(
					"custom-candle__print-data-form-visible"
				);
			});

		this.el
			.querySelector(".custom-candle__progress-bar__close-button")
			?.addEventListener("click", (event) => {
				document.body.classList.remove(
					"custom-candle__progress-bar-cta-visible"
				);
			});

		this.el
			.querySelector(".custom-candle__progress-bar__make-new-ancedote")
			?.addEventListener("click", (event) => {
				event.preventDefault();
				if (this.candleGpt) {
					this.setCandleGptMode("generate");
					applicationJS.scrollToAnchor("CandleGptPrompt", 20);
					window.setTimeout(() => {
						this.candleGpt?.promptInput?.focus({ preventScroll: true });
					}, 250);
				} else {
					let link = window.location.origin + "/pages/generator";
					if (document.body.classList.contains("has-print")) {
						window.location = link + "#return-to-event";
					} else {
						window.location = link;
					}
				}
			});
	}

	buildQuantitySelector() {
		let el = this.el;
		if (el.querySelector("#custom-candle__submit-wrapper")) {
			el.querySelector(
				"#custom-candle__submit-wrapper .purchase-form__quantity-select-plus"
			).addEventListener("click", (event) => {
				this.upQuantity(event, el);
			});
			el.querySelector(
				"#custom-candle__submit-wrapper .purchase-form__quantity-select-minus"
			).addEventListener("click", (event) => {
				this.downQuantity(event, el);
			});

			el.querySelector(
				"#custom-candle__submit-wrapper-mobile .purchase-form__quantity-select-plus"
			).addEventListener("click", (event) => {
				this.upQuantity(event, el);
			});
			el.querySelector(
				"#custom-candle__submit-wrapper-mobile .purchase-form__quantity-select-minus"
			).addEventListener("click", (event) => {
				this.downQuantity(event, el);
			});
		}
	}
	upQuantity(e, el) {
		let amount = 1;
		this.changeQuantity(el, amount);
	}

	downQuantity(e, el) {
		let amount = -1;
		this.changeQuantity(el, amount);
	}

	changeQuantity(el, dir) {
		let quant = parseInt(
			this.el.querySelector(".purchase-form__quantity-select-indicator")
				.innerHTML
		);
		quant = quant + dir;
		let minAmount = 1;

		if (quant < 1) {
			quant = minAmount;
		}

		el.querySelector(
			"#custom-candle__submit-wrapper .purchase-form__quantity-select-indicator"
		).innerHTML = quant;
		el.querySelector(
			"#custom-candle__submit-wrapper-mobile .purchase-form__quantity-select-indicator"
		).innerHTML = quant;
		el.querySelector("#quantity").value = quant;
	}

	getUrlInputs() {
		console.log("getUrlInputs");
		//let paramsString = decodeURIComponent(hash)
		console.log(window.location.search);
		const searchParams = new URLSearchParams(window.location.search);
		console.log(searchParams);
		// Iterating the search parameters
		for (const p of searchParams) {
			console.log(p);
		}

		if (searchParams.get("candleAnecdote")) {
			// check the last char
			if ("." == searchParams.get("candleAnecdote").slice(-1)) {
				this.el.querySelector("#CandleAnecdote").value = searchParams
					.get("candleAnecdote")
					.substring(0, searchParams.get("candleAnecdote").length - 1);
			} else {
				this.el.querySelector("#CandleAnecdote").value =
					searchParams.get("candleAnecdote");
			}
			this.el
				.querySelector("#CandleAnecdote")
				.classList.remove("no-rounded-bottom");
			if (this.candleGpt) {
				this.setCandleGptMode("write");
			}
		} else {
			this.el
				.querySelector("#CandleAnecdote")
				.classList.add("no-rounded-bottom");
		}

		if (searchParams.get("candleName")) {
			this.el.querySelector("#CandleName").value = searchParams
				.get("candleName")
				.trim();
			// Show input fields if candleName is provided via URL
			const fieldsContainer = this.el.querySelector(".candle-gpt-fields");
			if (fieldsContainer) {
				fieldsContainer.classList.add("is-visible");
			}
		}
		if (searchParams.get("candleDescription")) {
			this.el.querySelector("#CandleDescription").value = searchParams
				.get("candleDescription")
				.trim();
		}
		if (searchParams.get("typeColor")) {
			let colorOption = this.el.querySelector(
				'.customizer-label-color-option[data-typeColor="' +
					searchParams.get("typeColor") +
					'"]'
			);
			if (colorOption) {
				let nodelist = this.el.querySelectorAll(
					".customizer-label-color-option"
				);
				for (let i = 0; i < nodelist.length; i++) {
					nodelist[i].classList.remove(
						"customizer-label-color-option-selected"
					);
				}
				colorOption.classList.add("customizer-label-color-option-selected");
				this.el
					.querySelector(".customizer-label-color__no-user-interaction")
					?.classList.remove("customizer-label-color__no-user-interaction");
			}
		}

		let hasValidResult = false;
		if (searchParams.get("fragranceNote")) {
			let fragranceNote = searchParams.get("fragranceNote").trim();
			let nodelist = this.el.querySelectorAll(".customizer-fragrance-option");
			for (let i = 0; i < nodelist.length; i++) {
				console.log(fragranceNote + " " + nodelist[i].getAttribute("data-id"));
				if (fragranceNote == nodelist[i].getAttribute("data-id")) {
					nodelist[i].classList.add("customizer-fragrance-option-selected");
					hasValidResult = true;
					this.el
						.querySelector(
							".customizer-fragrance-selector__no-user-interaction"
						)
						?.classList.remove(
							"customizer-fragrance-selector__no-user-interaction"
						);
				} else {
					nodelist[i].classList.remove("customizer-fragrance-option-selected");
				}
			}
			if (false === hasValidResult) {
				nodelist[0].classList.add("customizer-fragrance-option-selected");
			}
		}

		this.updateSelector();
	}

	buildSubmitButton() {
		let nodelist = this.el.querySelectorAll(".custom-candle-submit");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.submitEvent(event);
			});
		}
		nodelist = this.el.querySelectorAll(".custom-candle-submit-print");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				document.body.classList.add("custom-candle__print-data-form-visible");
				applicationJS.scrollToAnchor("custom-candle__control-col");
			});
		}
	}

	buildPreviewButton() {
		let nodelist = this.el.querySelectorAll(".custom-candle-preview");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.candlePreviewEvent(event);
			});
		}
	}

	buildCandleDescriptionResetButton() {
		let nodelist = this.el.querySelectorAll(".CandleDescription-reset");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.candleDescriptionResetEvent(event);
			});
		}
	}

	candleDescriptionResetEvent(e) {
		const candleDescriptionEl = this.el.querySelector("#CandleDescription");
		if (candleDescriptionEl) {
			candleDescriptionEl.value = "";
			candleDescriptionEl.removeAttribute("data-user-cleared");
		}
		//this.el.querySelector('#CandleDescription').placeholder = ""
		this.candlePreviewEvent();
	}

	treatOptions(string) {
		// this will remove the last comma and any whitespace after it:
		return string.replace(/,\s*$/, "").split(",");
	}

	setVessel(key) {
		console.log("Set vessel");
		let nodelist = this.el.querySelectorAll(
			".custom-candle-vessel-selector .GridRow__card-selector"
		);
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.vesselChangeEvent(event, nodelist[i]);
			});
			//console.log(key +" : "+nodelist[i].getAttribute('data-id'))
			if (key === nodelist[i].getAttribute("data-id")) {
				nodelist[i].classList.add("custom-candle-vessel-selected");
			}
		}
	}

	setFragrance(key) {
		console.log("Set fragrance");
		let nodelist = this.el.querySelectorAll(
			".customizer-fragrance-selector .customizer-fragrance-option"
		);
		for (let i = 0; i < nodelist.length; i++) {
			//console.log(key +" "+nodelist[i].getAttribute('data-id'))
			if (key === nodelist[i].getAttribute("data-id")) {
				nodelist[i].classList.add("customizer-fragrance-option-selected");
			}
		}
	}

	buildFragrances() {
		console.log("buildFragrances");
		let nodelist = this.variantSelector.querySelectorAll("option");
		let arr = [];

		for (let i = 0; i < nodelist.length; i++) {
			let fragrance = this.treatOptions(
				nodelist[i].getAttribute("data-options")
			);
			if (!arr.includes(fragrance[1])) {
				this.el.querySelector(".customizer-fragrance-selector").innerHTML +=
					"<div class='col-8 mb-md' ><div class='customizer-fragrance-option pt-xs pb-xs pl-lg pr-lg text-center font-md'  data-id='" +
					fragrance[1] +
					"' >" +
					fragrance[1] +
					"</div></div>";
				arr.push(fragrance[1]);
			}
		}

		nodelist = this.el.querySelectorAll(".customizer-fragrance-option");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.fragranceChangeEvent(event, nodelist[i]);
				// Rotate to front when selecting fragrance
				this.rotateLabelToView("front");
			});
		}

		// Select the first fragrance option by default if user hasn't interacted
		const noUserInteraction = this.el.querySelector(
			".customizer-fragrance-selector__no-user-interaction"
		);
		if (noUserInteraction && nodelist.length > 0) {
			// Check if any fragrance is already selected
			const hasSelected = Array.from(nodelist).some((option) =>
				option.classList.contains("customizer-fragrance-option-selected")
			);
			if (!hasSelected) {
				// Select the first fragrance option
				nodelist[0].classList.add("customizer-fragrance-option-selected");
			}
		}
	}

	buildLabelColors() {
		// Default color definitions
		let defaultColorDef = [
			{ labelColor: "#FCF8F1", typeColor: "#000000", label: "Black" },
			{ labelColor: "#FCF8F1", typeColor: "#E46875", label: "Coral" },
			{ labelColor: "#FCF8F1", typeColor: "#EC6B5A", label: "Orange" },
			{ labelColor: "#FCF8F1", typeColor: "#E4BD51", label: "Yellow" },
			{ labelColor: "#FCF8F1", typeColor: "#5BA880", label: "Jade" },
			{ labelColor: "#FCF8F1", typeColor: "#5779BC", label: "Blue" },
			{ labelColor: "#FCF8F1", typeColor: "#485773", label: "Navy" },
			{ labelColor: "#FCF8F1", typeColor: "#A779C1", label: "Purple" },
		];

		// Try to get custom color definitions from data attribute
		let colorDef = defaultColorDef;
		const customCandleInterface = this.el.querySelector(
			"#custom-candle-interface"
		);
		if (customCandleInterface) {
			const customColorsJson = customCandleInterface.getAttribute(
				"data-custom-label-colors"
			);
			if (customColorsJson) {
				try {
					const parsedColors = JSON.parse(customColorsJson);
					if (Array.isArray(parsedColors) && parsedColors.length > 0) {
						// Transform metaobject structure to expected format
						// Metaobjects have: { name, type_color }
						// Expected format: { labelColor, typeColor, label }
						colorDef = parsedColors.map((color) => {
							// Ensure type_color is a string (handle cases where it might be an object)
							let typeColorValue = color.type_color;
							if (
								typeof typeColorValue === "object" &&
								typeColorValue !== null
							) {
								// If it's an object, try to get a string value
								// Color metafields might have .value, .hex, or other properties
								typeColorValue =
									typeColorValue.value ||
									typeColorValue.hex ||
									typeColorValue.toString() ||
									"#000000";
							}
							if (typeof typeColorValue !== "string") {
								typeColorValue = String(typeColorValue || "#000000");
							}

							// Ensure name is a string
							let nameValue = color.name;
							if (typeof nameValue === "object" && nameValue !== null) {
								nameValue =
									nameValue.value || nameValue.toString() || "Unknown";
							}
							if (typeof nameValue !== "string") {
								nameValue = String(nameValue || "Unknown");
							}

							return {
								labelColor: "#FCF8F1", // Default label color
								typeColor: typeColorValue,
								label: nameValue,
							};
						});
					}
				} catch (e) {
					console.warn(
						"Failed to parse custom label colors from metafield:",
						e
					);
				}
			}
		}
		let template = this.el.querySelector(".customizer-label-color-option");
		console.log(template);
		this.el.querySelector(".customizer-label-color").innerHTML = "";

		for (let i = 0; i < colorDef.length; i++) {
			let def = colorDef[i];
			// Ensure all values are strings for data attributes
			const typeColor = String(def.typeColor || "#000000");
			const labelColor = String(def.labelColor || "#FCF8F1");
			const label = String(def.label || "Unknown");

			template
				.querySelector(".customizer-label-color-option__inner")
				.setAttribute("style", "background:#fff;color:" + typeColor);
			template.setAttribute("data-labelColor", labelColor);
			template.setAttribute("data-typeColor", typeColor);
			template.setAttribute("data-typeColorText", label);
			template.querySelector(
				".customizer-label-color-option__inner"
			).innerHTML = label;
			template.innerHTML +=
				'<style> div[data-typeColor="' +
				typeColor +
				'"]:hover, div.customizer-label-color-option-selected[data-typeColor="' +
				typeColor +
				'"] {border-color: ' +
				typeColor +
				" }</style>";

			if (i === 0) {
				template.classList.add("customizer-label-color-option-selected");
			} else {
				template.classList.remove("customizer-label-color-option-selected");
			}
			//labelColors[i].classList.remove('customizer-label-color-selected')
			this.el.querySelector(".customizer-label-color").innerHTML +=
				"<div class=' mb-md col-8  ' >" + template.outerHTML + "</div>";
		}

		let nodelist = this.el.querySelectorAll(".customizer-label-color-option");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].addEventListener("click", (event) => {
				this.colorChangeEvent(event, nodelist[i]);
				// Rotate to front when selecting color
				this.rotateLabelToView("front");
			});
		}
	}

	checkEmoji(string) {
		if (/\p{Extended_Pictographic}/u.test(string)) {
			return true;
		}
	}

	updateSelector() {
		console.log("updateSelector");
		let currentVessel = this.el.querySelector(".custom-candle-vessel-selected");
		let currentFragrance = this.el.querySelector(
			".customizer-fragrance-option-selected"
		);

		// Safety check: ensure both vessel and fragrance are found
		if (!currentVessel || !currentFragrance) {
			console.warn("updateSelector: vessel or fragrance not found", {
				vessel: currentVessel,
				fragrance: currentFragrance,
			});
			return;
		}

		let searchString =
			currentVessel.getAttribute("data-id") +
			"," +
			currentFragrance.getAttribute("data-id") +
			",";
		console.log(searchString);
		let selector = this.el.querySelector(".variantId-select");
		let selection = this.el.querySelector(
			'.variantId-select option[data-options="' + searchString + '"] '
		);

		// Safety check: ensure selection exists
		if (!selection || !selector) {
			console.warn("updateSelector: variant selection not found", {
				selector: selector,
				selection: selection,
				searchString: searchString,
			});
			return;
		}

		selector.value = selection.value;
		console.log(selection);
		this.selectVariant(selection.value);
		this.candlePreviewEvent();
	}

	colorChangeEvent(e, el) {
		console.log("colorChangeEvent");
		this.el
			.querySelector(".customizer-label-color__no-user-interaction")
			?.classList.remove("customizer-label-color__no-user-interaction");

		let nodelist = this.el.querySelectorAll(".customizer-label-color-option");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].classList.remove("customizer-label-color-option-selected");
		}
		e.currentTarget.classList.add("customizer-label-color-option-selected");
		this.candlePreviewEvent();
	}

	vesselChangeEvent(e, el) {
		console.log("vesselChangeEvent");
		let nodelist = this.el.querySelectorAll(
			".custom-candle-vessel-selector .GridRow__card-selector"
		);
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].classList.remove("custom-candle-vessel-selected");
		}
		e.currentTarget.classList.add("custom-candle-vessel-selected");
		this.updateSelector();
	}

	fragranceChangeEvent(e, el) {
		console.log("fragranceChangeEvent");

		this.el
			.querySelector(".customizer-fragrance-selector__no-user-interaction")
			?.classList.remove("customizer-fragrance-selector__no-user-interaction");
		let nodelist = this.el.querySelectorAll(".customizer-fragrance-option");
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].classList.remove("customizer-fragrance-option-selected");
		}
		e.currentTarget.classList.add("customizer-fragrance-option-selected");
		this.updateSelector();
		// Always update preview when fragrance changes, even if updateSelector fails
		this.candlePreviewEvent();
	}

	manageDefaultCandleDescriptions(candleDescriptionEl, fragranceNoteEl) {
		console.log("--> Manage Default Candle Descriptions:");

		let nodelist = this.el.querySelectorAll(".variantId-select option");
		let currentDescription = candleDescriptionEl.value;
		//console.log(currentDescription)
		for (let i = 0; i < nodelist.length; i++) {
			let descriptionOption = nodelist[i].getAttribute(
				"data-fragrance-description"
			);
			// check if default description is used and switch to another default
			//console.log(descriptionOption)
			if (
				"" != descriptionOption && currentDescription == descriptionOption
			) {
				//console.log("currentDescription == descriptionOption user hasn't modified switching to default option")
				//console.log(descriptionOption)
				let candleDescription = fragranceNoteEl.getAttribute(
					"data-fragrance-description"
				);
				candleDescriptionEl.value = candleDescription;
				break;
			} else {
			}
		}
	}

	isCandleDescriptionUserCleared(candleDescriptionEl) {
		if (!candleDescriptionEl) {
			return false;
		}
		return candleDescriptionEl.getAttribute("data-user-cleared") === "true";
	}

	getInputs(mode) {
		console.log("getInputs");

		let candleName = this.el.querySelector("#CandleName");
		let candleAnecdote = this.el.querySelector("#CandleAnecdote");
		let companyName = this.el.querySelector("#CompanyName");
		let candleDescriptionEl = this.el.querySelector("#CandleDescription");
		let variantIdSelect = this.el.querySelector(".variantId-select");
		let labelColorOption = this.el.querySelector(
			".customizer-label-color-option-selected"
		);
		let fragranceOption = this.el.querySelector(
			".customizer-fragrance-option-selected"
		);
		let vesselOption = this.el.querySelector(".custom-candle-vessel-selected");

		/*
             candleName.classList.remove('form-error')
             candleAnecdote.classList.remove('form-error')

             let message = ""
             if("" == candleName.value){
               message+= "Please set a candle name\n"
               candleName.classList.add('form-error')
             }
             if("" == candleAnecdote.value){
               message+= "Please set a candle anecdote\n"
               candleAnecdote.classList.add('form-error')
             }

             if("" != message){
               alert(message)
               return false
             }
        */

		// Get fragrance note from variant selector - prefer matching the selected fragrance option
		let fragranceNoteEl = null;
		if (variantIdSelect && fragranceOption) {
			// First try to get from currently selected variant
			let selectedOption = variantIdSelect.querySelector(
				'option[value="' + variantIdSelect.value + '"]'
			);

			// Check if selected variant matches the selected fragrance
			if (selectedOption) {
				let selectedOptions = this.treatOptions(
					selectedOption.getAttribute("data-options")
				);
				if (selectedOptions[1] === fragranceOption.getAttribute("data-id")) {
					// Selected variant matches the selected fragrance - use it
					fragranceNoteEl = selectedOption;
				} else {
					// Selected variant doesn't match - find a variant that matches the selected fragrance
					let allOptions = variantIdSelect.querySelectorAll("option");
					for (let i = 0; i < allOptions.length; i++) {
						let optionData = this.treatOptions(
							allOptions[i].getAttribute("data-options")
						);
						if (optionData[1] === fragranceOption.getAttribute("data-id")) {
							fragranceNoteEl = allOptions[i];
							break;
						}
					}
				}
			}

			// Fallback to currently selected option if no match found
			if (!fragranceNoteEl && selectedOption) {
				fragranceNoteEl = selectedOption;
			}
		} else if (variantIdSelect) {
			// Fallback: get from currently selected variant if no fragrance option is found
			fragranceNoteEl = variantIdSelect.querySelector(
				'option[value="' + variantIdSelect.value + '"]'
			);
		}

		let candleDescription = candleDescriptionEl
			? candleDescriptionEl.value
			: "";
		if (
			"" == candleDescription &&
			fragranceNoteEl &&
			!this.isCandleDescriptionUserCleared(candleDescriptionEl)
		) {
			candleDescription = fragranceNoteEl.getAttribute(
				"data-fragrance-description"
			);
			if (candleDescriptionEl) {
				candleDescriptionEl.value = fragranceNoteEl.getAttribute(
					"data-fragrance-description"
				);
			}
		} else if (
			candleDescriptionEl &&
			fragranceNoteEl &&
			!this.isCandleDescriptionUserCleared(candleDescriptionEl)
		) {
			this.manageDefaultCandleDescriptions(
				candleDescriptionEl,
				fragranceNoteEl
			);
			candleDescription = candleDescriptionEl.value;
		}

		let blockBuyButton = false;
		if (candleName && this.checkEmoji(candleName.value)) {
			this.el
				.querySelector(".custom-candle__step-name")
				.classList.add("custom-candle__has-error");
			blockBuyButton = true;
		} else {
			let stepName = this.el.querySelector(".custom-candle__step-name");
			if (stepName) {
				stepName.classList.remove("custom-candle__has-error");
			}
		}

		if (candleAnecdote && this.checkEmoji(candleAnecdote.value)) {
			this.el
				.querySelector(".custom-candle__step-candle-anecdote")
				.classList.add("custom-candle__has-error");
			blockBuyButton = true;
		} else {
			let stepAnecdote = this.el.querySelector(
				".custom-candle__step-candle-anecdote"
			);
			if (stepAnecdote) {
				stepAnecdote.classList.remove("custom-candle__has-error");
			}
		}

		if (this.checkEmoji(candleDescription)) {
			this.el
				.querySelector(".custom-candle__step-candle-description")
				.classList.add("custom-candle__has-error");
			blockBuyButton = true;
		} else {
			this.el
				.querySelector(".custom-candle__step-candle-description")
				.classList.remove("custom-candle__has-error");
		}

		let submitButtons = this.el.querySelectorAll(".custom-candle-submit");
		if (blockBuyButton == true) {
			submitButtons.forEach((userItem) => {
				userItem.setAttribute("disabled", true);
			});
		} else {
			submitButtons.forEach((userItem) => {
				userItem.removeAttribute("disabled");
			});
		}

		// Get fragrance note - use variant option's data-fragrance if available, otherwise use fragrance option's data-id as fallback
		let fragranceNote = "";
		if (fragranceNoteEl) {
			fragranceNote = fragranceNoteEl.getAttribute("data-fragrance") || "";
		}
		// Fallback: if we can't get fragrance note from variant option, use fragrance option's data-id
		if (!fragranceNote && fragranceOption) {
			fragranceNote = fragranceOption.getAttribute("data-id") || "";
		}

		let productId = "";
		let customCandleInterface = this.el.querySelector(
			"#custom-candle-interface"
		);
		if (customCandleInterface) {
			productId = customCandleInterface.getAttribute("data-product-id") || "";
		}

		const metafieldCandleName = customCandleInterface
			? customCandleInterface
					.getAttribute("data-default-candle-name")
					?.trim()
			: "";
		const metafieldAnecdote = customCandleInterface
			? customCandleInterface.getAttribute("data-default-anecdote")?.trim()
			: "";

		let candleNameValue = candleName ? candleName.value : "";
		let candleAnecdoteValue = candleAnecdote ? candleAnecdote.value : "";
		if ("" === candleNameValue.trim() && metafieldCandleName) {
			candleNameValue = metafieldCandleName;
		}
		if ("" === candleAnecdoteValue.trim() && metafieldAnecdote) {
			const normalizedAnecdote = metafieldAnecdote.trim();
			candleAnecdoteValue = /^smells like\s+/i.test(normalizedAnecdote)
				? normalizedAnecdote
				: `Smells like ${normalizedAnecdote}`;
		}

		let properties = {
			candleName: candleNameValue,
			candleAnecdote: candleAnecdoteValue,
			candleDescription: candleDescription,
			companyName: companyName ? companyName.value : "",
			productId: productId,
			labelColor: labelColorOption
				? labelColorOption.getAttribute("data-labelcolor")
				: "",
			fragranceDataId: fragranceOption
				? fragranceOption.getAttribute("data-id")
				: "",
			fragranceNote: fragranceNote,
			typeColor: labelColorOption
				? labelColorOption.getAttribute("data-typecolor")
				: "",
			typeColorText: labelColorOption
				? labelColorOption.getAttribute("data-typecolortext")
				: "",
			variantIdSelect: variantIdSelect ? variantIdSelect.value : "",
			printSize: vesselOption
				? vesselOption.getAttribute("data-print-size")
				: "",
			lastPrompt: document.body.getAttribute('data-last-prompt')
		};

		if (document.body.classList.contains("has-print")) {
			properties.shippingAddressFirstName =
				this.el.querySelector("#firstname").value;
			properties.shippingAddressLastName =
				this.el.querySelector("#lastname").value;
			properties.email = this.el.querySelector("#email").value;
		}

		let searchParams = new URLSearchParams(properties);
		properties.pdfLink = searchParams.toString();

		if ("hidden" == mode) {
			properties = {
				_candleName: properties.candleName,
				_lastPrompt: properties.lastPrompt,
				_candleAnecdote: properties.candleAnecdote,
				_candleDescription: properties.candleDescription,
				_companyName: properties.companyName,
				_labelColor: properties.labelColor,
				_fragranceDataId: properties.fragranceDataId,
				_fragranceNote: properties.fragranceNote,
				_typeColor: properties.typeColor,
				_typeColorText: properties.typeColorText,
				_variantIdSelect: properties.variantIdSelect,
				_printSize: properties.printSize,
				_pdfLink: properties.pdfLink,
				Name: properties.candleName,
				Anecdote: properties.candleAnecdote,
				Fragrance: properties.fragranceNote,
				Color: properties.typeColorText,
			};
		}
		return properties;
	}

	validateExtraPrintInputs(properties) {
		console.log("validateExtraPrintInputs");
		this.el
			.querySelector(".custom-candle-submit__validate")
			.classList.add("d-none");
		this.el.querySelector("#firstname").classList.remove("form-error");
		this.el.querySelector("#lastname").classList.remove("form-error");
		this.el.querySelector("#email").classList.remove("form-error");

		let message = [];
		if ("" == this.el.querySelector("#firstname").value) {
			message.push("First Name");
			this.el.querySelector("#firstname").classList.add("form-error");
		}
		if ("" == this.el.querySelector("#lastname").value) {
			message.push("Last Name");
			this.el.querySelector("#lastname").classList.add("form-error");
		}
		// as of Oct 24 we are no longer validating emails
		if ("" == this.el.querySelector("#email").value) {
			//message.push("Email")
			//this.el.querySelector('#email').classList.add('form-error')
		}
		if ("" != message) {
			message = "Please set the following:<br>" + message.join(", ");
			//applicationJS.displayInModal("<div class='d-flex justify-content-center flex-direction-column align-items-center'><h5 class=\"headline-2 pb-xl color-golden-brown text-center\">Error</h5><div class='texteditor-content font-md pb-md'>"+message+"</div></div>",'above-cart')

			this.el
				.querySelector(".custom-candle-submit__validate")
				.classList.remove("d-none");
			this.el.querySelector(".custom-candle-submit__validate").innerHTML =
				message;
			return false;
		}
		return true;
	}

	submitEvent(e) {
		e.preventDefault();
		let variantIdSelect = this.el.querySelector(".variantId-select");
		let quantity = this.el.querySelector(
			".purchase-form__quantity-select-indicator"
		).innerHTML;
		let properties = this.getInputs("hidden");
		let items = [];
		let item = {
			quantity: quantity,
			id: variantIdSelect.value,
			properties: properties,
		};
		console.log("submitEvent");
		console.log(properties);

		if (document.body.classList.contains("has-print")) {
			if (!this.validateExtraPrintInputs(properties)) {
				return false;
			}
			let printUrl =
				"https://customizer-prod.uk.r.appspot.com/index.php?action=LabelRenderer&direct-print=true&timestamp=" +
				Date.now() +
				"&" +
				properties._pdfLink;
			//let printUrl ='https://tnbw-staging.com/site-builder/anecdote/index.php?action=LabelRenderer&direct-print=true&'+properties._pdfLink
			console.log(printUrl);
			let xhr = new XMLHttpRequest();
			xhr.overrideMimeType("application/json");
			xhr.open("GET", printUrl, true);
			xhr.send(null);
			xhr.onreadystatechange = function () {
				let DONE = 4;
				let OK = 200;
				if (xhr.readyState === DONE) {
					if (xhr.status === OK) {
						let jsonResponse = JSON.parse(xhr.responseText);
						/*
                        applicationJS.displayInModal("<div class='d-flex justify-content-center flex-direction-column align-items-center'><h5 class=\"headline-2 pb-xl color-golden-brown text-center\">\n" +jsonResponse.message+
                            "    </h5><div class='d-flex justify-content-center flex-direction-row align-items-center mt-lg mb-lg ' ><a href=\"https://anecdotecandles.com/products/anecdote-custom-candle-event\"  class=\"button btn-sm btn-outline mr-md \">Make a new custom candle</a><a href=\"https://anecdotecandles.com/pages/generator#return-to-event\"  class=\"button btn-sm btn-black \" >Generate a new anecdote</a></div></div>",'above-cart')
                        */
						console.log(jsonResponse);
						if ("print_job_saved" == jsonResponse.status) {
							document.querySelector("#firstname").value = "";
							document.querySelector("#lastname").value = "";
							document.querySelector("#email").value = "";
							document
								.querySelector(".custom-candle-submit__success")
								.classList.remove("d-none");
							let timeout = setTimeout(function () {
								document
									.querySelector(".custom-candle-submit__success")
									.classList.add("d-none");
								document.body.classList.remove(
									"custom-candle__print-data-form-visible"
								);
								window.location =
									"https://anecdotecandles.com/products/anecdote-custom-candle-event";
							}, 2000);
						} else {
							alert(
								"An error occurred: " +
									jsonResponse.errors +
									". Please try again."
							);
						}
					}
				}
			};
		} else {
			document.body.setAttribute(
				"data-closeCartEvent",
				"customCandleBuilder.postAddEvent()"
			);
			items.push(item);
			AjaxCart.add(items);
		}
	}

	postAddEvent() {
		console.log("postAddEvent");
		document.body.classList.add("custom-candle__progress-bar-cta-visible");
	}

	candlePreviewEvent(e) {
		let properties = this.getInputs();
		console.log(properties);

		// check progress bars
		if (document.getElementById("custom-candle__progress-bar")) {
			if ("" == properties.candleName || "" == properties.candleAnecdote) {
				document
					.querySelector(".custom-candle__progress-bar__copy")
					.classList.remove("custom-candle__step-completed");
			} else {
				document
					.querySelector(".custom-candle__progress-bar__copy")
					.classList.add("custom-candle__step-completed");
			}

			if (
				"" == properties.fragranceNote ||
				this.el.querySelectorAll(
					".customizer-fragrance-selector__no-user-interaction"
				).length != 0
			) {
				document
					.querySelector(".custom-candle__progress-bar__fragrance")
					.classList.remove("custom-candle__step-completed");
			} else {
				document
					.querySelector(".custom-candle__progress-bar__fragrance")
					.classList.add("custom-candle__step-completed");
			}
			if (
				"" == properties.labelColor ||
				this.el.querySelectorAll(".customizer-label-color__no-user-interaction")
					.length != 0
			) {
				document
					.querySelector(".custom-candle__progress-bar__color")
					.classList.remove("custom-candle__step-completed");
			} else {
				document
					.querySelector(".custom-candle__progress-bar__color")
					.classList.add("custom-candle__step-completed");
			}
		}
		//this.renderVisualPreviewWithCanvas(properties)

		// Reuse existing VisualPreviewGenerator instance if it exists to preserve 3D preview
		// This prevents flicker from reinitializing the 3D scene
		if (!this.visualPreview) {
			let visualPreview = new VisualPreviewGenerator(this.el);
			this.visualPreview = visualPreview; // Store reference for 3D preview module

			// Set global instance for toggle button
			if (typeof window !== "undefined") {
				window.currentVisualPreviewInstance = visualPreview;
				if (typeof window.setVisualPreviewInstance === "function") {
					window.setVisualPreviewInstance(visualPreview);
				}
			}
		}

		this.visualPreview.renderVisualPreviewWithCanvas(properties);
		this.drawEvent();
		this.updateUrl(properties);
		//this.renderVisualPreview(properties)
	}

	updateUrl(properties) {
		console.log("updateUrl " + window.location.hash);
		history.pushState(
			{},
			properties.candleName,
			window.location.origin +
				window.location.pathname +
				"?" +
				properties.pdfLink +
				window.location.hash
		);
	}

	renderVisualPreview(properties) {
		let imageUrl =
			"https://tnbw-staging.com/site-builder/anecdote/index.php?action=LabelRenderer&render-png=true&" +
			properties.pdfLink;
		if (
			!this.el.querySelector("#card-preview .card-preview__front-image img")
		) {
			this.el.querySelector(
				"#card-preview .card-preview__front-image"
			).innerHTML =
				'<img class=" width-100" alt="Design preview front" src="' +
				imageUrl +
				'" /><div class="custom-candle__progress-indicator d-none" aria-hidden="true" >' +
				document.getElementById("spinning-loader").innerHTML +
				"</div>";
			this.el.querySelector(
				"#card-preview .card-preview__back-image"
			).innerHTML =
				'<img class=" width-100" alt="Design preview back" src="' +
				imageUrl +
				'" /><div  class="custom-candle__progress-indicator d-none" aria-hidden="true" >' +
				document.getElementById("spinning-loader").innerHTML +
				"</div>";
		}

		let image = this.el.querySelector(
			"#card-preview .card-preview__front-image img"
		);
		let nodelist = this.el.querySelectorAll(
			".custom-candle__progress-indicator"
		);
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].classList.remove("d-none");
		}
		let context = this;
		image.onload = function () {
			context.drawEvent();
		};
		image.src = imageUrl;
		this.el.querySelector("#card-preview .card-preview__back-image img").src =
			imageUrl;
	}

	drawEvent() {
		console.log("image loaded");
		let nodelist = document.querySelectorAll(
			".custom-candle__progress-indicator"
		);
		for (let i = 0; i < nodelist.length; i++) {
			nodelist[i].classList.add("d-none");
		}
		document.body.classList.add("customizer-body-background");
		document
			.querySelector("#custom-candle-interface")
			?.classList.remove("opacity-0");
	}
}

let customCandleBuilder;
function loadPortraitItalic() {
	let PortraitItalicFontFace = new FontFace(
		"PortraitItalic",
		"url(" + portraitItalicUrl + ")"
	);
	document.fonts.add(PortraitItalicFontFace);
	PortraitItalicFontFace.load().then(() => {
		console.log("PortraitItalicFontFace loaded");
		customCandleBuilder = new CustomCandleClass(document.body);
	});
}

function loadDaubenton() {
	let DaubentonWebFontFace = new FontFace(
		"DaubentonWeb",
		"url(" + daubentonWebUrl + ")"
	);
	document.fonts.add(DaubentonWebFontFace);
	DaubentonWebFontFace.load().then(() => {
		console.log("DaubentonWebFontFace loaded");
		loadPortraitItalic();
	});
}
function loadPortraitHeavy() {
	let PortraitHeavyFontFace = new FontFace(
		"PortraitHeavy",
		"url(" + portraitHeavyUrl + ")"
	);
	document.fonts.add(PortraitHeavyFontFace);
	PortraitHeavyFontFace.load().then(() => {
		console.log("PortraitHeavyFontFace loaded");
		loadDaubenton();
	});
}

const PortraitRegularFontFace = new FontFace(
	"PortraitRegular",
	"url(" + portraitRegularUrl + ")"
);
document.fonts.add(PortraitRegularFontFace);
PortraitRegularFontFace.load().then(() => {
	loadPortraitHeavy();
});
